import { isSelected } from "@utilities";

export const STEP_8_VALIDATIONS = [
  {
    field: "clientProfile.0.data.directMarketing",
    validation: isSelected
  },
  {
    field: "clientProfile.0.data.clientChannel",
    validation: isSelected
  }
];
